import React from 'react'
import PropTypes from 'prop-types'
import {
  Row,
  Col,
  TabContent,
  TabPane,
} from 'reactstrap'
import { OnlineInStoreBadge, PreApprovedBadge } from './SelectionCardBadges'

const SelectionPane = ({ activeTab, paneList }) => {

  return (
    <TabContent activeTab={activeTab}>
      {paneList.map((pane, index) => (
        <TabPane
          key={`selection-pane-${pane.productCode || index}`}
          tabId={index}
          className={`${activeTab === index ? 'border border-primary selection-pane' : ''} `}
        >
          <div className="p-3">
            <Col sm="12">
              <Row className="d-flex align-items-center mb-4">
                <Col xs="6" sm="8" className="mb-0 d-flex align-items-center">
                  {pane.paneTitle}
                </Col>
                <Col className="d-flex justify-content-end align-items-center" xs="6" sm="4">
                  <OnlineInStoreBadge
                    visible={pane.onlineInStore}
                    productCode={pane.productCode}
                    onlineOnly={pane.onlineOnly}
                    text={pane.onlineInStoreText}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  {pane.description}
                </Col>
              </Row>

              <Row>
                <Col sm="12">
                  <PreApprovedBadge
                    visible={pane.preApproved}
                    productCode={pane.productCode}
                    onlineOnly={pane.onlineOnly}
                    text={pane.preApprovedText}
                    icon={pane.preApprovedIcon}
                  />
                </Col>
              </Row>

            </Col>
          </div>
        </TabPane>
      ))}
    </TabContent>
  )
}

SelectionPane.propTypes = {
  activeTab: PropTypes.number.isRequired,
  paneList: PropTypes.arrayOf(
    PropTypes.shape({
      productCode: PropTypes.string,
      paneTitle: PropTypes.node,
      description: PropTypes.node,
      onlineInStore: PropTypes.bool,
      preApproved: PropTypes.bool,
      onlineOnly: PropTypes.bool,
      onlineInStoreText: PropTypes.string,
      preApprovedText: PropTypes.string,
      preApprovedIcon: PropTypes.string,
    })
  ).isRequired,
}

export default SelectionPane
